import { type FC } from 'react';

import { SMART_PLAYGROUND_ITEMS } from '@entities/catalog';
import { CatalogSection } from '@widgets/catalog-section';

const SmartPlaygroundPage: FC = () => (
  <CatalogSection
    title="Умная спортивная площадка"
    shortTitle="Умная площадка"
    overviewImage="/equipment/smart-playground/Ограждение+воркаут.webp"
    overviewSize={{ width: 1600, height: 793 }}
    basePath="/catalog/smart-playground"
    items={SMART_PLAYGROUND_ITEMS}
  />
);

export default SmartPlaygroundPage;
